/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { DataManagerAdaptersGlyph } from '@jira/servicedesk__insight-landing-page/src/DataManagerAdaptersGlyph.tsx';
import { getDataManagerAdaptersUrl } from '@jira/servicedesk__insight-common-utils-insight-urls/src/getLandingPageUrl.tsx';
import { ASSETS_ADAPTERS } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import { useFormattedMessageAndIcon } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import ArrowUpRightIcon from '@atlaskit/icon/core/arrow-up-right';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useAssetsUIAnalytics } from '../../use-assets-ui-analytics/index.tsx';

const jsmAssetsDataManagerAdapters = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-data-manager-adapters',

	defaultMessage: 'Adapters',
	description: 'Assets dropdown item to link customer to Data manager Adapters page.',
});

const jsmAssetsOpenDataManager = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.jsm-assets-open-data-manager',

	defaultMessage: 'Open data manager',
	description: 'Open data manager icon label',
});

const assetsDataManagerBeta = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-assets.common.data-manager-adapter.assets-data-manager-beta',

	defaultMessage: 'Beta',
	description: 'Indicates that the product is in "beta" (early access)',
});

export const DataManagerAdapterMenuItems = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const { icon: formattedAdapterIcon } = useFormattedMessageAndIcon(
		jsmAssetsDataManagerAdapters,
		DataManagerAdaptersGlyph,
	);

	const { icon: formattedOpenIcon } = useFormattedMessageAndIcon(
		jsmAssetsOpenDataManager,
		ArrowUpRightIcon,
	);

	const { fireUINavigationItemAnalytics } = useAssetsUIAnalytics();

	return (
		<LinkMenuItem
			elemBefore={formattedAdapterIcon}
			elemAfter={formattedOpenIcon}
			href={getDataManagerAdaptersUrl()}
			target="_blank"
			onClick={() => fireUINavigationItemAnalytics(ASSETS_ADAPTERS)}
		>
			<Inline space="space.050" alignBlock="baseline">
				{formatMessage(jsmAssetsDataManagerAdapters)}
				<Lozenge appearance="discovery">{formatMessage(assetsDataManagerBeta)}</Lozenge>
			</Inline>
		</LinkMenuItem>
	);
};
